<template>
  <div class="product-item">
    <div>
      <div class="product-item__image-container">
        <product-badges
            v-if="!!product.is_limited_series || !!product.is_long_term_production"
            position="bottom-left"
            :is-limited-series="!!product.is_limited_series"
            :is-long-term-production="!!product.is_long_term_production"
        />
        <a
            class="cursor-pointer product-item__image-link"
            @click="goToProductCard(productCardParams)"
        >
          <img
              v-if="product.image_id"
              class="cover"
              alt=""
              :src="getProductImageSrc(product.image_id)"
          />
          <img
              v-else
              src="@/assets/images/default-product-image.jpg"
              alt=""
              class="cover"
          />
        </a>
      </div>

      <a
          :class="{
          'offers product-item__link cursor-pointer hover-underline': true,
          'h-25': isCurrentUserStructuralSubdivisionUser
        }"
          @click="goToProductCard(productCardParams)"
      >
        {{ product.name }}
        <span v-if="product.quantity && product.quantity > 1">
          ({{ product.quantity }} {{ productUnitLabel }})
        </span>
      </a>
    </div>

    <div class="product-item__info">
      <p v-if="isCurrentUserDealer && product.price > 0" class="price">
        {{ product.price | fractionSizeSpace }}
        {{ makeDeclension(product.price, 'балл', 'балла', 'баллов') }}
      </p>

      <template v-if="isCurrentUserStructuralSubdivisionUser">
        <p class="price f-size-14">Доступно для заказа:</p>
        <p class="price f-size-14">
          {{ product.balance }} <small>{{ productUnitLabel }}</small>
        </p>
      </template>

      <div v-if="isCurrentUserDealer" class="price-for-item">
        <div v-if="product.price_for_unit" class="offers">
          {{ product.price_for_unit | fractionSizeSpace }} за 1 {{ productUnitLabel }}
        </div>
        <p v-if="product.count" class="offers-count">
          В наличии: {{ product.count.count }} компл.
        </p>
      </div>

      <template v-if="!closePurchaseByDate">
        <div
            v-if="product.is_available > 0 || isCurrentUserStructuralSubdivisionUser"
            class="product-actions"
        >
          <template v-if="availableAddToBasket">
            <div class="add-to-basket-row">
              <template v-if="!showSizeSelect">
                <button
                    :class="['send-to-basket', { 'in-cart': displayedInCart }]"
                    type="button"
                    @click="displayedInCart ? goToCart() : addItem()"
                >
                  {{ displayedInCart ? 'В корзине' : 'В корзину' }}
                </button>

                <cart-line-product-quantity
                    v-if="storeQuantity > 0"
                    :product-id="String(product.id)"
                    :size-id="null"
                    :quantity="storeQuantity"
                    :item-not-available="(product.count && product.count.count && product.count.count > 0) ? product.count.count : 9999999999"
                    :is-limited="product.is_limited_series"
                    :balance="isCurrentUserStructuralSubdivisionUser ? product.balance : null"
                />
              </template>

              <div v-else class="size-select">
                <p class="size-select__label">Выберите размер:</p>
                <v-select
                    :options="product.sizes"
                    v-model="selectedSize"
                    label="name"
                    class="sizes size-select__select"
                    append-to-body
                    ref="sizeSelect"
                    @input="selectSize"
                />
              </div>
            </div>
          </template>

          <button
              v-if="!itemIsInCart && product.price == 0"
              class="item-in-basket"
              type="button"
              disabled
          >
            Недоступен для заказа
          </button>
        </div>

        <div v-if="product.is_available === 0 || product.is_available === false" class="product-actions">
          <button class="item-in-basket default-cursor" type="button">
            Нет в наличии
          </button>
        </div>
      </template>

      <div v-else class="product-actions">
        <button class="closeOrderLabel" type="button" @click="showWarningAlert">
          Недоступно до <br />
          {{ closeOrdersDealerByDate }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { error, success } from '@/lib/toasted'
import { showPurchaseByDate } from '@/lib/swal2'
import EntityMixin from '@/mixins/EntityMixin'
import ProductBadges from './ProductBadges.vue'
import CartLineProductQuantity from '../dealer/CartLineProductQuantity.vue'

export default {
  name: 'PopularProductsItem',
  mixins: [EntityMixin],
  components: { ProductBadges, CartLineProductQuantity },
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    selectedSize: null,
    showSizeSelect: false,
    isInCartLocal: false,
  }),
  methods: {
    ...mapActions('cart', ['addProduct', 'goToCart', 'fetchCartInfo']),
    ...mapActions('catalog', ['goToProductCard']),

    async addItem() {
      if (this.sizesExist) {
        this.showSizeSelect = true;
        this.openSizeSelect();
        success('Пожалуйста выберите размер.');
        return;
      }

      // Проверка доступного количества
      if (this.product.is_available > 0 && this.storeQuantity >= this.product.is_available) {
        return;
      }

      // Проверка для структурных подразделений
      if (this.isCurrentUserStructuralSubdivisionUser && this.storeQuantity >= this.product.balance) {
        error('Превышено максимально допустимое количество товара');
        return;
      }

      const added = await this.addProduct({ productId: this.product.id });
      if (added) this.isInCartLocal = true;
    },

    async selectSize(size) {
      await this.addProduct({ productId: this.product.id, size: size.id })
    },

    openSizeSelect() {
      this.$refs.sizeSelect.open = true
    },

    showWarningAlert() {
      showPurchaseByDate(
          'Прием заказов прекращен до ' +
          this.closeOrdersDealerByDate +
          '. С информацией можно ознакомиться в разделе <a style="text-decoration: underline;" href="/how-to-order">«Как заказать?»</a>'
      )
    },
  },
  async mounted() {
    if (window.__cartInfoPromise) {
      await window.__cartInfoPromise
    } else {
      window.__cartInfoPromise = this.fetchCartInfo().finally(() => {
        window.__cartInfoPromise = null
      })
      await window.__cartInfoPromise
    }
  },
  computed: {
    ...mapGetters('account', ['isCurrentUserStructuralSubdivisionUser']),
    ...mapGetters('cart', ['isProductInCart', 'getItemInCartCount']),
    ...mapGetters('common', ['getProductImageSrc', 'makeDeclension']),
    ...mapGetters('builtInParameter', ['closeOrdersDealerByDate']),

    closePurchaseByDate() {
      return (
          this.closeOrdersDealerByDate !== '' &&
          !(this.isCurrentUserDealer && this.product.count)
      )
    },

    itemIsInCart() {
      return this.isProductInCart(this.product.id)
    },

    productCardParams() {
      const product = this.product;
      return {
        product,
        sectionPath: product.section_path,
        categoryPath: product.category_path,
        productPath: product.slug
      };
    },

    availableAddToBasket() {
      return this.product.price > 0 && this.product.is_available > 0
    },

    sizesExist() {
      return this.product.sizes && this.product.sizes.length > 0
    },

    storeQuantity() {
      return this.getItemInCartCount(this.product.id)
    },

    displayedInCart() {
      return this.storeQuantity > 0 || this.isInCartLocal
    },
    productUnitLabel() {
      return 'шт.'
    },
  },
  watch: {
    storeQuantity(val) {
      if (val === 0) {
        this.isInCartLocal = false
      }
    },
  },
}
</script>

<style lang="sass" scoped>
.product-item
  padding-bottom: 25px
  height: 100%
  display: flex
  flex-direction: column
  justify-content: space-between
  &__link
    margin: 20px 0
  &__image-container
    position: relative
  &__image-link, &__image-link img
    width: 100%
  &__info
    display: flex
    flex-direction: column
    align-items: baseline
.product-actions
  display: flex
  flex-direction: column
  flex: 1
  justify-content: flex-end

.add-to-basket-row
  display: flex
  align-items: center
  gap: 10px

.send-to-basket
  background-color: #d93030 /* пример красного фона */
  color: #fff
  border: 1px solid transparent
  padding: 8px 12px
  cursor: pointer
  border-radius: 4px

/* инвертированное состояние: белый фон, красный текст и рамка */
.send-to-basket.in-cart
  background-color: #fff
  color: #d93030
  border: 1px solid #d93030

.default-cursor
  cursor: default


.f-size-14
  font-size: 14px


.h-25
  height: 25px

.cover
  object-fit: cover
  height: 279px

.size-select
  &__label
    font-size: 14px
    font-weight: bold
    margin-bottom: 0.3rem

  &__select
    margin-top: 9px
    width: 150px

.dropdown-menu::v-deep
  z-index: 10030 !important
.closeOrderLabel
  border: none
</style>
